export const API_URI = 'https://helpinghand.dev.bossdigital.tech';
